import type { ExperienceListItem, HomeExperienceCard } from '../types';

/**
 * Pass-through adapter: o HomeExperienceCard ja carrega quase tudo que o
 * ExperienceCard precisa (images, description, tags, restriction). Gaps vs.
 * a detail DTO:
 *   - videoUrl: card nunca renderiza, default ''
 *   - minParticipants/maxParticipants: home payload nao traz pra reduzir
 *     tamanho. Card tambem nao mostra capacidade (so detail), default 0.
 *     Detail busca a experiencia completa via /experience-catalog/code/{code}
 *     que tem os valores reais.
 */
export function homeCardToListItem(c: HomeExperienceCard): ExperienceListItem {
  return {
    experienceCode: c.experienceCode,
    slug: c.slug,
    title: c.title,
    description: c.description,
    summary: c.summary,
    restriction: c.restriction,
    location: c.location,
    citySlugs: c.citySlugs,
    category: c.category,
    price: c.price,
    priceUnit: c.priceUnit,
    currency: c.currency,
    duration: c.duration,
    distanceKm: c.distanceKm,
    images: c.images,
    videoUrl: '',
    tags: c.tags,
    tagSlugs: c.tagSlugs,
    experienceTier: c.experienceTier,
    bookingType: c.bookingType,
    // O home payload não traz availabilityType (mesmo motivo de min/maxParticipants:
    // card não usa, só o booking flow). Default seguro = SlotBased; detail page
    // busca a experiência completa via /experience-catalog/code/{code}.
    availabilityType: 'SlotBased',
    minParticipants: 0,
    maxParticipants: 0,
  };
}
